/*
 * Prime Phones — collection pages (sections/pp-collection-top.liquid and the
 * Prime Phones layout of main-collection-product-grid.liquid).
 *
 *  - The small filter icon presses the theme's own (hidden) "Filter and sort"
 *    button, so the theme's drawer, filters and sort work exactly as before.
 *    The drawer closes with the theme's close button, a tap on the dimmed
 *    page, Esc, or a swipe towards its edge (the drawer follows the finger;
 *    past a third of its width, or a quick flick, it closes; otherwise it
 *    slides back). The WhatsApp bubble steps aside while it's open.
 *  - Smart picks: show only the phones in stock that match; the same pick
 *    again, or "Show all", brings everything back. Picks are worked out on the
 *    server from the phones on the page, so a pick is never empty. When the
 *    theme re-renders the grid (a filter or sort changes), picks start fresh.
 *  - Google rating: read from the reviews app's public data once in a while
 *    (cached), so the number on the page stays true.
 * One set of listeners on the document, so it keeps working after re-renders.
 * No look-behind in any pattern (older Safari).
 */
(function () {
  if (window.__ppCollection) return;
  window.__ppCollection = true;

  /* ---------- the filter icon ---------- */
  function openFilters() {
    var open = document.querySelector('#main-collection-filters .mobile-facets__open-wrapper') ||
      document.querySelector('.mobile-facets__open-wrapper');
    if (!open) return false;
    open.click();
    return true;
  }

  var FILTERS = '#main-collection-filters details.mobile-facets__disclosure';

  /* Open or closed (the theme adds and removes [open]): the icon says so to
     screen readers, the WhatsApp bubble steps aside, and on closing the
     focus goes back to the icon rather than the theme's hidden button. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches(FILTERS)) return;
    document.body.classList.toggle('pp-filters-open', d.open);
    var icon = document.querySelector('[data-ppcg-filter]');
    if (!icon) return;
    icon.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    if (!d.open && document.activeElement === d.querySelector('summary')) icon.focus({ preventScroll: true });
  }, true);

  /* ---------- swipe the filter drawer closed ---------- */
  var SIDE = document.documentElement.dir === 'rtl' ? -1 : 1;
  var drag = null;

  function paintDrag() {
    if (!drag) return;
    drag.raf = 0;
    drag.inner.style.transform = 'translateX(' + (drag.dx * SIDE) + 'px)';
    if (drag.close) drag.close.style.transform = drag.inner.style.transform;
    drag.details.style.setProperty('--ppf-shade', String(Math.max(0, 1 + drag.dx / drag.w)));
  }

  function endDrag(e, cancelled) {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (d.raf) cancelAnimationFrame(d.raf);
    if (!d.on) return;
    var v = e && e.timeStamp - d.t < 100 ? d.v : 0;
    var close = !cancelled && ((d.dx < -d.w / 3 && v < 0.2) || (v < -0.45 && d.dx < -24));
    /* Handing back to the theme's own transition, from where the finger left it. */
    d.details.classList.remove('is-dragging');
    d.inner.style.transform = '';
    if (d.close) d.close.style.transform = '';
    d.details.style.removeProperty('--ppf-shade');
    if (close && d.details.classList.contains('menu-opening')) {
      var summary = d.details.querySelector('summary');
      if (summary) summary.click();
    }
  }

  document.addEventListener('touchstart', function (e) {
    if (drag || e.touches.length !== 1) return;
    var t = e.target;
    var inner = t && t.closest && t.closest('#main-collection-filters .mobile-facets__inner');
    if (!inner) return;
    /* The price slider and the price boxes keep their own gestures. */
    if (t.closest('.price-range, textarea, input:not([type="checkbox"]):not([type="radio"])')) return;
    var details = inner.closest('details');
    if (!details || !details.classList.contains('menu-opening')) return;
    var p = e.touches[0];
    drag = { details: details, inner: inner, close: details.querySelector('.mobile-facets__close'), w: inner.offsetWidth || 1, x: p.clientX, y: p.clientY, dx: 0, on: false, dead: false, lx: p.clientX, t: e.timeStamp, v: 0, raf: 0 };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!drag || drag.dead) return;
    var p = e.touches[0];
    var dx = (p.clientX - drag.x) * SIDE;
    var dy = p.clientY - drag.y;
    if (!drag.on) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      /* Only a sideways move towards the drawer's edge; anything else scrolls. */
      if (dx > -8 || Math.abs(dx) < Math.abs(dy) * 1.2) {
        drag.dead = true;
        return;
      }
      drag.on = true;
      drag.details.classList.add('is-dragging');
    }
    var dt = e.timeStamp - drag.t;
    if (dt > 0) drag.v = (p.clientX - drag.lx) * SIDE / dt;
    drag.lx = p.clientX;
    drag.t = e.timeStamp;
    drag.dx = Math.min(0, dx);
    if (!drag.raf) drag.raf = requestAnimationFrame(paintDrag);
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (drag && e.touches.length === 0) endDrag(e, false);
  }, { passive: true });

  document.addEventListener('touchcancel', function (e) {
    endDrag(e, true);
  }, { passive: true });

  /* Motion (batch 3): once a filter has been used, the phone count ticks each time it changes. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('facet-filters-form')) document.body.classList.add('pp-filtered');
  });

  /* ---------- smart picks ---------- */
  function matches(card, pick) {
    var d = card.dataset;
    if (d.ppAvail !== '1') return false;
    var kind = pick.getAttribute('data-ppcg-pick');
    if (kind === 'bat') return Number(d.ppBat) >= Number(pick.getAttribute('data-min'));
    if (kind === 'under') return Number(d.ppPrice) < Number(pick.getAttribute('data-max'));
    if (kind === 'new') return Number(d.ppGen) === Number(pick.getAttribute('data-gen'));
    if (kind === 'save') return Number(d.ppSave) > 0 && Number(d.ppSave) >= Number(pick.getAttribute('data-min'));
    if (kind === 'gb') return Number(d.ppGb) === Number(pick.getAttribute('data-gb'));
    return true;
  }

  function countLine(bar, n) {
    var tpl = n === 1 ? bar.getAttribute('data-one') : bar.getAttribute('data-many');
    return String(tpl || '').replace('[n]', n);
  }

  /* Motion (batch 3): phones that stay glide to their new places, phones
     that appear fade in — only those near the screen, and only when motion
     is on. The filtering itself happens at once; this only plays after it. */
  var html = document.documentElement;
  var glide = function () {
    return html.classList.contains('pp-m-coll') && typeof Element.prototype.animate === 'function';
  };
  var near = function (r) { return r.bottom > -200 && r.top < window.innerHeight + 200; };

  function apply(bar, pick) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var shown = 0;
    var items = grid.querySelectorAll('.ppcg-item');
    var before = glide() ? new Map() : null;
    if (before) items.forEach(function (li) { if (!li.classList.contains('is-hidden')) before.set(li, li.getBoundingClientRect()); });
    items.forEach(function (li) {
      var card = li.querySelector('[data-pp-card]');
      var show = !pick || (card && matches(card, pick));
      li.classList.toggle('is-hidden', !show);
      if (show) shown++;
    });
    if (before) {
      items.forEach(function (li) {
        if (li.classList.contains('is-hidden')) return;
        var a = li.getBoundingClientRect();
        if (!near(a)) return;
        var b = before.get(li);
        if (b) {
          var dx = b.left - a.left, dy = b.top - a.top;
          if (Math.abs(dx) > 1 || Math.abs(dy) > 1) li.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 420, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
        } else {
          li.animate([{ opacity: 0, transform: 'scale(0.96)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
        }
      });
    }
    /* The Prime Phones AI card follows the phones that are showing. */
    var ai = grid.querySelector('[data-ppcg-ai]');
    if (ai) {
      if (pick) {
        if (!ai.__ppHome) ai.__ppHome = ai.nextElementSibling || 'end';
        grid.appendChild(ai);
      } else if (ai.__ppHome) {
        if (ai.__ppHome === 'end' || !ai.__ppHome.parentNode) grid.appendChild(ai);
        else grid.insertBefore(ai, ai.__ppHome);
        ai.__ppHome = null;
      }
    }
    var count = bar.querySelector('[data-ppcg-count]');
    if (count) {
      count.textContent = countLine(bar, shown);
      count.classList.remove('pp-tick');
      void count.offsetWidth;
      count.classList.add('pp-tick');
    }
    var all = bar.querySelector('[data-ppcg-all]');
    if (all) all.hidden = !pick;
    bar.classList.toggle('is-picked', !!pick);
  }

  function choose(pick) {
    var bar = pick.closest('[data-ppcg-bar]');
    if (!bar) return;
    var wasOn = pick.getAttribute('aria-pressed') === 'true';
    bar.querySelectorAll('[data-ppcg-pick]').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
    if (wasOn) {
      apply(bar, null);
      return;
    }
    pick.setAttribute('aria-pressed', 'true');
    apply(bar, pick);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var filter = t.closest('[data-ppcg-filter]');
    if (filter) {
      if (openFilters()) e.preventDefault();
      return;
    }
    var pick = t.closest('[data-ppcg-pick]');
    if (pick) {
      e.preventDefault();
      choose(pick);
      return;
    }
    var all = t.closest('[data-ppcg-all]');
    if (all) {
      e.preventDefault();
      var bar = all.closest('[data-ppcg-bar]');
      if (!bar) return;
      bar.querySelectorAll('[data-ppcg-pick]').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
      apply(bar, null);
      var first = bar.querySelector('[data-ppcg-pick]');
      if (first) first.focus();
    }
  });

  /* ---------- Google rating ---------- */
  var KEY = 'pp-google-rating';
  var MAX_AGE = 6 * 60 * 60 * 1000;

  function paint(el, v) {
    var r = Math.round(Number(v.r) * 10) / 10;
    if (!(r > 0 && r <= 5)) return;
    var text = r.toFixed(1);
    var value = el.querySelector('[data-ppct-value]');
    if (value) value.textContent = text;
    var stars = el.querySelector('[data-ppct-stars]');
    if (stars) stars.style.setProperty('--ppct-r', (r / 5 * 100) + '%');
    var sr = el.querySelector('[data-ppct-sr]');
    if (sr && sr.getAttribute('data-tpl')) sr.textContent = sr.getAttribute('data-tpl').replace('[n]', text);
    if (v.url && el.tagName === 'A' && !el.getAttribute('href')) el.setAttribute('href', v.url);
  }

  function rating() {
    var el = document.querySelector('[data-ppct-rating][data-shop]');
    if (!el) return;
    var hit = null;
    try { hit = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { hit = null; }
    if (hit && hit.r) paint(el, hit);
    if (hit && Date.now() - hit.t < MAX_AGE) return;
    var run = function () {
      fetch('https://grw.reputon.com/app/storefront/widget?shop=' + encodeURIComponent(el.getAttribute('data-shop')) + '&lang=en')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (j) {
          var b = j && j.business && j.business[0];
          if (!b || !b.rating) return;
          var v = { r: Number(b.rating), url: b.url || '', t: Date.now() };
          try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode: just paint */ }
          paint(el, v);
        })
        .catch(function () { /* keep the number set in the theme editor */ });
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 4000 });
    else setTimeout(run, 1500);
  }

  /* The theme's "Filter & sort" button is kept out of sight (the filter icon presses it, see
     pp-collection.css): it gets its name and leaves the keyboard order, so the keyboard never lands
     on an invisible, nameless control. */
  function quietFilterButton() {
    document.querySelectorAll('#main-collection-filters .mobile-facets__open-wrapper').forEach(function (s) {
      var l = s.querySelector('.mobile-facets__open-label.visible-xs') || s.querySelector('.mobile-facets__open-label');
      if (l && !s.hasAttribute('aria-label')) s.setAttribute('aria-label', l.textContent.replace(/\s+/g, ' ').trim());
      s.setAttribute('tabindex', '-1');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', quietFilterButton);
  else quietFilterButton();
  document.addEventListener('pp:section:load', quietFilterButton);
  document.addEventListener('shopify:section:load', quietFilterButton);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rating);
  else rating();
  /* Shop swapped in by the bottom bar (assets/pp-app-nav.js) */
  document.addEventListener('pp:section:load', function (e) { if (e.target.querySelector && e.target.querySelector('[data-ppct-rating]')) rating(); });
})();
